import {gql} from '@apollo/client';

export const QUERY_COLLECTIONS = gql`
query collections($filters: CollectionFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []) {
    collections(filters: $filters, pagination: $pagination, sort: $sort) {
        documentId
        name
        enabled
    }
}`

export const QUERY_COLLECTION = gql`
    query collection($documentId: ID!) {
        collection(documentId: $documentId) {
            documentId
            name
            enabled
        }
    }`